import 'bootstrap';
import 'hiraku/js/jquery-hiraku.min';
import Swiper from'swiper/bundle';
import"../scss/style.scss";

/**
 * パララックススクロール
 */
//初期設定
var $window = $(window),
    wh = window.innerHeight,
    nowScroll = $window.scrollTop(),
    reg = -0.8;//調整値、負の数だとスクロール時に上に動き、正の数だと下に動く。絶対値が大きいほど動く量が小さくなる。

$window.on('load resize', function () {
    wh = window.innerHeight;
    nowScroll = $window.scrollTop();
});
window.addEventListener('scroll', function () {
    nowScroll = $window.scrollTop();
}, { passive: true });

//トリガー
var $paraItem = $('#div1');
if ($paraItem.length) {
    parallax();
    $window.on('load resize', parallax);
    window.addEventListener('scroll', parallax);
}

//処理内容
function parallax() {
    $paraItem.each(function () {
        var $this = $(this),
        scroll_bottom = nowScroll + wh;
        $this.css('transform', '');

        var nowpos = $this.offset().top;
        if (nowpos < scroll_bottom) {
            $this.css('left', ( ((scroll_bottom - nowpos) / reg)+ 465 + 'px'));
        }
    });
}

/*
* sp menu
*/
$('#nav__btn').on("click",function(){
    $('html').toggleClass('stop-scroll');
    $(this).toggleClass('active');
    $('#sp__nav').toggleClass('active');
});

//swiper スライダー
let swipeOption = {
    loop: true,
    effect: 'fade',
    autoplay: {
        delay: 4000,
        disableOnInteraction: false,
    },
    speed: 2500,
}
new Swiper('.swiper-container', swipeOption);

/**
 * 郵便番号からの住所自動入力
 */
jQuery(function($){
    $("input.zipcode").on("focusout", function() {
        let zipcode = $(this).val();
        $.ajax({
            url: 'https://api.zipaddress.net/?zipcode=' + zipcode,
            dataType: 'json',
            async: false,
            success: function(response) {
                $('select.prefecture option').filter(function(index){
                    return $(this).text() === response.data.pref;
                }).prop('selected', true);
                $('input.address').val(response.data.city + response.data.town);
            },
            error: function(response) {
                console.log('郵便番号から住所の検索に失敗しました');
            }
        });
    });
});

document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = 'https://reallink.co.jp/contact/thanks/';
}, false );
